export enum LanguageName {
  "العربية" = "العربية",
  "English" = "English",
  "Spanish" = "Spanish",
  "Francais" = "Francais",
}
